/**
 * @file
 * Tabs functionality for switching between tab panels.
 */

(function ($) {
  "use strict";

  Drupal.behaviors.umsiTabs = {
    attach: function (context, settings) {
      $(once("umsiTabs", ".tabs-component", context)).each(function () {
        var $wrapper = $(this);
        var $tabLinks = $wrapper.find(".tabs__item-link");
        var $tabPanels = $wrapper.find(".tab-panel");

        // Hide all panels except the active one
        $tabPanels.not(".active").hide();

        // Handle tab click
        $tabLinks.on("click", function (e) {
          e.preventDefault();
          var targetId = $(this).attr("href");

          // Remove active class from all tabs and panels
          $wrapper.find(".tabs__item").removeClass("active");
          $tabPanels.removeClass("active").hide();

          // Add active class to clicked tab and show corresponding panel
          $(this).parent(".tabs__item").addClass("active");
          $(targetId).addClass("active").show();
        });
      });
    },
  };
})(jQuery, Drupal, once);
